import { styled } from '@mui/material'

import { theme } from 'styles/theme'

interface NotificationWrapperProps {
  isUnread: boolean
}

export const NotificationWrapper = styled('div')<NotificationWrapperProps>(
  ({ isUnread }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    padding: '12px 16px',
    cursor: 'pointer',
    transition: 'background-color 150ms linear',
    backgroundColor: isUnread ? theme.palette.neutral[900] : 'transparent',
    borderLeft: isUnread
      ? `2px solid ${theme.palette.neutral[600]}`
      : '2px solid transparent',
    position: 'relative',
    '&:hover': {
      backgroundColor: theme.palette.neutral[800]
    },
    '& + &': {
      borderTop: `1px solid ${theme.palette.neutral[700]}`
    }
  })
)

interface IconWrapperProps {
  bgColor?: string
}

export const IconWrapper = styled('div')<IconWrapperProps>(({ bgColor }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '36px',
  height: '36px',
  borderRadius: '10px',
  backgroundColor: bgColor || theme.palette.neutral[800],
  flexShrink: 0,
  marginTop: '1px'
}))

export const ContentWrapper = styled('div')(() => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '3px',
  overflow: 'hidden',
  minWidth: 0
}))

export const TopRow = styled('div')(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: '8px'
}))

export const Title = styled('span')(() => ({
  margin: 0,
  fontSize: '13px',
  fontWeight: 600,
  fontFamily: 'Inter, sans-serif',
  color: theme.palette.neutral[200],
  lineHeight: 1.45,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical'
}))

export const Time = styled('span')(() => ({
  fontSize: '11px',
  fontWeight: 400,
  fontFamily: 'Inter, sans-serif',
  color: theme.palette.neutral[500],
  whiteSpace: 'nowrap',
  flexShrink: 0,
  lineHeight: '20px'
}))

interface BodyProps {
  expanded?: boolean
}

export const Body = styled('p')<BodyProps>(({ expanded }) => ({
  margin: 0,
  fontSize: '12px',
  fontWeight: 400,
  fontFamily: 'Inter, sans-serif',
  color: theme.palette.neutral[400],
  lineHeight: 1.5,
  ...(expanded
    ? {}
    : {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical' as const
      })
}))

interface ExpandToggleProps {
  expanded?: boolean
}

export const ExpandToggle = styled('button')<ExpandToggleProps>(
  ({ expanded }) => ({
    background: 'none',
    border: 'none',
    padding: 0,
    margin: 0,
    marginLeft: 'auto',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.neutral[500],
    transition: 'transform 200ms ease, color 150ms ease',
    transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
    '&:hover': {
      color: theme.palette.neutral[300]
    }
  })
)

export const MetaRow = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  marginTop: '2px'
}))

export const TypeBadge = styled('span')(() => ({
  fontSize: '10px',
  fontWeight: 500,
  fontFamily: 'Inter, sans-serif',
  color: theme.palette.neutral[400],
  backgroundColor: theme.palette.neutral[800],
  padding: '2px 7px',
  borderRadius: '4px',
  lineHeight: '14px',
  textTransform: 'capitalize'
}))

export const UnreadDot = styled('span')(() => ({
  width: '6px',
  height: '6px',
  borderRadius: '50%',
  backgroundColor: theme.palette.primary[100],
  flexShrink: 0
}))
